module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-thin-straight-X52T7FDE.eot?da5370367c68591325a78b117c737bce";